module.exports = __webpack_public_path__ + "static/4-8b38721a4e3f46014191a388a9d5fb6e.jpg";